import { Controller } from "@hotwired/stimulus";

/**
 * 枠をクリックした時に、内部のリンクやコントロールへ移譲する
 * @example
 * <div data-controller="clickable-area">
 *  ここをクリックすると↓のリンクがクリックされる
 *  <a href="/path/to" data-clickable-area-target="element">→</a>
 * </div>
 */
export class ClickableAreaController extends Controller {
  static targets = ["element"];
  static values = { preventDefault: { type: Boolean, default: false } };

  connect() {
    this.handler = (event) => this.#handleClick(event);
    this.element.addEventListener("click", this.handler);
  }

  disconnect() {
    this.element.removeEventListener("click", this.handler);
  }

  #handleClick(event) {
    if (!this.hasElementTarget) return;
    if (event.target === this.elementTarget) return;
    if (event.target.closest("a, button, input, select, textarea")) return;

    if (this.preventDefaultValue) {
      event.preventDefault();
    }
    this.elementTarget.click();
  }
}
